/* eslint-disable no-unused-expressions */
import React, { useEffect, useMemo, useState } from 'react';
import { Steps } from 'intro.js-react';

import bannerPurpleMetricsWeb from 'assets/images/banner-purple-metrics-web.png';
import bannerPurpleMetricsMobile from 'assets/images/banner-purple-metrics-mobile.png';

import Navbar from 'components/layout/NavbarNew';
import UserMenu from 'components/layout/UserMenu';
import CTOS from 'components/layout/Portal/ctos';
import MinhasSolicitacoes from 'components/layout/Portal/MinhasSolicitacoes';
import Pesquisa from 'components/layout/Portal/Pesquisa';
import ConsumptionHistory from 'components/layout/Portal/ConsumptionHistory';

import scrollBlock from 'utils/functions/scrollBlock';
import { useTour } from 'hooks/useTour';
import TourBalloon from 'newComponents/NewTour/TourBallon';
import BannerPromotions from 'BannerPromotions';
import { useHistory } from 'react-router-dom';
import { BasesProvider } from 'components/layout/Portal/MinhasSolicitacoes/hooks/useBases';
import PreviewRefuel from 'components/layout/Portal/MinhasSolicitacoes/PreviewRefuel';
import { useMediaQuery } from 'react-responsive';
import { steps, stepsMobile } from './steps';

import {
  CtosWrap,
  HistoryWrap,
  ImageBannerPurpleMetrics,
  LinkPurpleMetrics,
  Main,
  PrevAbastecimentoWrap,
  PurpleMetricsWrap,
  SolicitationsWrap,
} from './styles';

declare global {
  interface Window {
    TrackWidget: any;
  }
}

const NewPortal = (): JSX.Element => {
  const [stepsEnabled, setStepsEnabled] = useState(false);
  const [stepResponsive, setStepResponsive] = useState(false);
  const [initialStep] = useState(0);

  const isMobile = useMediaQuery({ maxWidth: 620 });

  const history = useHistory();

  const [haveToken] = useState(
    localStorage.getItem('@UltragazEmpresarial:accessToken')
  );

  const [haveCustomerCode] = useState(
    localStorage.getItem('@UltragazEmpresarial:customerCode')
  );

  const { showTour, tourType, tourStep, setTourType, setSteps } = useTour();

  useEffect(() => {
    setTourType('home');
    setSteps(6);
  }, [showTour, setTourType, setSteps]);

  useEffect(() => {
    if (showTour && tourType === 'home' && tourStep === 5) {
      const el = document.getElementById('consumption-container');
      if (el) {
        el.scrollIntoView();
      }
    }
    if (showTour && tourType === 'home' && tourStep < 5) {
      const el = document.getElementById('user-menu');
      if (el) {
        el.scrollIntoView();
      }
    }
  }, [showTour, tourType, tourStep]);

  const setStepResponsiveVoid = (): void => {
    if (window.matchMedia('(max-width: 1100px)').matches) {
      setStepResponsive(true);
    } else {
      setStepResponsive(false);
    }
  };

  const toggleSteps = (): void => {
    setStepResponsiveVoid();
    setStepsEnabled((prev) => !prev);
    scrollBlock('#outer-container', 'body', true);
  };

  const onExit = (): void => {
    setStepsEnabled(false);
    scrollBlock('#outer-container', 'body', false);
  };

  if (haveToken && !haveCustomerCode) {
    history.push('/endereco');
  }

  const urlDashBoard = useMemo(() => {
    if (
      process.env.REACT_APP_ENV === 'build-prod' ||
      process.env.REACT_APP_ENV === 'prod'
    ) {
      return 'https://dashboard.purplemetrics.com.br/widget/survey/index.html?company=634118e1-c91a-46f0-a3b7-f78d874aaead&segment=402';
    }
    return 'https://dashboard.purplemetrics.com.br/widget/survey/index.html?company=634118e1-c91a-46f0-a3b7-f78d874aaead&segment=402&isDebug=true';
  }, []);

  return (
    <>
      <Navbar selected="inicio">
        <UserMenu intro={toggleSteps} />
        <Steps
          enabled={stepsEnabled}
          steps={stepResponsive ? stepsMobile : steps}
          initialStep={initialStep}
          onExit={onExit}
          options={{
            skipLabel: "<span class='mdi mdi-close'></span>",
            doneLabel: "<span class='mdi mdi-close'></span>",
            showStepNumbers: false,
            scrollToElement: false,
          }}
        />
        <Main>
          <PurpleMetricsWrap>
            <LinkPurpleMetrics
              href={urlDashBoard}
              rel="noreferrer"
              target="_blank"
            >
              <ImageBannerPurpleMetrics
                src={
                  isMobile ? bannerPurpleMetricsMobile : bannerPurpleMetricsWeb
                }
              />
            </LinkPurpleMetrics>
          </PurpleMetricsWrap>
          <PrevAbastecimentoWrap>
            <BasesProvider>
              <PreviewRefuel />
            </BasesProvider>
          </PrevAbastecimentoWrap>
          <CtosWrap
            showTour={showTour && tourType === 'home' && tourStep === 4}
          >
            <CTOS />
            {showTour && tourType === 'home' && tourStep === 4 && (
              <TourBalloon
                title="Acessos rápidos"
                content="Através de um clique você poderá ter acesso à funcionalidade que desejar, de forma fácil e rápida."
                position={{
                  left: '50%',
                  right: '0',
                  top: '98%',
                  arrowPosition: 'top',
                  width: '320px',
                  maxWidth: 'unset',
                  transform: 'translateX(-50%)',
                }}
              />
            )}
          </CtosWrap>
          <SolicitationsWrap
            showTour={showTour && tourType === 'home' && tourStep === 5}
          >
            <MinhasSolicitacoes />
            {showTour && tourType === 'home' && tourStep === 5 && (
              <TourBalloon
                title="Status de solicitações"
                content="Aqui são exibidos os status de suas solicitações. Você poderá acompanhar os pedidos de abastecimento e solicitações de manutenção."
                position={{
                  left: '50%',
                  right: '0',
                  top: '98%',
                  arrowPosition: 'top',
                  maxWidth: 265,
                  transform: 'translateX(-50%)',
                }}
              />
            )}
          </SolicitationsWrap>
          <HistoryWrap
            id="consumption-container"
            showTour={showTour && tourType === 'home' && tourStep === 6}
          >
            <ConsumptionHistory />
            {showTour && tourType === 'home' && tourStep === 6 && (
              <TourBalloon
                title="Histórico de consumo"
                content="Aqui você encontra as informações do histórico de consumo. Através de um clique você poderá filtrar o período desejado e salvar as informações em uma planilha de forma fácil e rápida."
                position={{
                  left: '30%',
                  right: '0',
                  top: '-81%',
                  arrowPosition: 'bottom',
                  maxWidth: 260,
                }}
              />
            )}
          </HistoryWrap>
        </Main>
      </Navbar>
      <Pesquisa />
      <BannerPromotions />
    </>
  );
};

export default NewPortal;
